import React, { useContext, useEffect, useState } from "react";
import { DataContext } from "../../../Context/DataContext";
import { AuthContext } from "../../../Context/AuthContext";
import { NotificationContext } from "../../../Context/NotificationContext";
import BillingPeriodPopUp from "./BillingPeriodPopUp";
import { ReactComponent as EditIcon } from "../../../assets/icons/Edit-black.svg";
import { firestore } from "../../../firebase.config";

const PaymentApproach = ({ defaultCard, pendingInvoices }) => {
  const { userData, teamData, setOrder } = useContext(DataContext);
  const { signedIn } = useContext(AuthContext);
  const { showNotification } = useContext(NotificationContext);

  const [billingTerm, setBillingTerm] = useState("case-by-case");
  const [billingPeriod, setBillingPeriod] = useState(null);
  const [showPeriodPopUp, setShowPeriodPopUp] = useState(false);

  useEffect(() => {
    if (signedIn && userData && userData.teamId && teamData ) {
      setBillingTerm(teamData.billingTerm || "case-by-case");
      setBillingPeriod(teamData.billingPeriod || null);
    }
  }, [signedIn, userData, teamData]);

  const updateBillingInDB = async (type, period) => {
    if (!signedIn || !userData) return;

    const ref = firestore.collection("teams").doc(userData.teamId)

    try {
      await ref.update({
        billingTerm: type,
        billingPeriod: period,
        lastInvoiceTimestamp: teamData.billingPeriod === "case-by-case" ? new Date().getTime() : teamData.lastInvoiceTimestamp,
      });
      setBillingTerm(type);
      setBillingPeriod(period);
      setShowPeriodPopUp(false);
    } catch (error) {
      showNotification("Error", "Failed to update billing. Try again!", "error");
    }
  };

  const handleBillingSelection = (type, period = null) => {
    if (isMember() || (type === "case-by-case" && pendingInvoices)) return;
    if (type !== "case-by-case" && !defaultCard) return showNotification("Warning", "Link a payment method first!", "warning");

    if (type === "own") {
      setShowPeriodPopUp(true);
      setBillingTerm(type);
    } else {
      updateBillingInDB(type, period);
    }

    localStorage.setItem(
      "order",
      JSON.stringify({ orderID: "", name: "", email: "", parsed: true })
    );
    setOrder({ orderID: "", name: "", email: "", parsed: true });
  };

  const isMember = () => {
    return userData.teamId && ["admin", "owner"].includes(userData.teamRole) ? false : true;
  };


  return (
    <div className="paymentApproachWrap">
      {showPeriodPopUp && (
        <BillingPeriodPopUp
          onSave={updateBillingInDB}
          billingPeriod={billingPeriod}
          setShowPeriodPopUp={setShowPeriodPopUp}
          setBillingPeriod={setBillingPeriod}
        />
      )}

      <h4 className="quotePrimaryTitle">Payment Approach</h4>

      <div
        className={`caseByCaseBtn fullWidthBillingBtn ${
          (isMember() || pendingInvoices ) && "disabledBillingBtn"
        } ${billingTerm === "case-by-case" && "selectedBillingTerm"}`}
        onClick={() => (!isMember() && !pendingInvoices) && handleBillingSelection("case-by-case")}
      >
        Case-by-Case <span>(Pay for each order separately)</span>
      </div>

      <p className="billingTermText">
        Or select a billing term and pay for all orders at the end of the billing term.
      </p>

      {!defaultCard && (
        <p className="billingTermDisabledText">
          To select a billing term you need to link or set a payment method as default.
        </p>
      )}

      <div className="billingTermBtns">
        {["weekly", "bi-weekly", "monthly"].map((term) => (
          <div
            key={term}
            className={`caseByCaseBtn ${
              (isMember() || !defaultCard ) && "disabledBillingBtn"
            } ${billingTerm === term && "selectedBillingTerm"}`}
            onClick={() => !isMember() && defaultCard && handleBillingSelection(term, term === "weekly" ? 7 : term === "bi-weekly" ? 14 : 30)}
          >
            {term.charAt(0).toUpperCase() + term.slice(1)}
          </div>
        ))}

        <div
          className={`caseByCaseBtn billingPeriodBtn ${
            (isMember() || !defaultCard ) && "disabledBillingBtn"
          } ${billingTerm === "own" && "selectedBillingTerm"} ${
            billingTerm === "own" ? "!justify-between" : "!justify-start"
          }`}
          onClick={() => !isMember() && defaultCard && handleBillingSelection("own")}
        >
          <div>Own Billing Period</div>
          {billingPeriod > 0 && billingTerm === "own" && (
            <div className="billingPeriod">Every {billingPeriod} days</div>
          )}
          {billingPeriod > 0 && billingTerm === "own" && (
            <EditIcon className="editBillingPeriod" />
          )}
        </div>
      </div>
    </div>
  );
};

export default PaymentApproach;
